import axios, { type AxiosResponse, type RawAxiosRequestHeaders } from 'axios';

/* this is inplace as at this time when we get an error from the
akamai system THD will send some sort page like the "Oops we are fixing it"
page. We decided that instaed we'd just render the appropriate error message
set up for whatever request is being made */
function handleAkamaiErrorResponse() {
  return Promise.reject(new Error('Oops something went wrong.'));
}

const AxiosClient = axios.create({
  withCredentials: true,
});

AxiosClient.interceptors.request.use((config) => {
  const tmxProfileId =
    typeof window !== 'undefined'
      ? window.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId()
      : undefined;
  if (tmxProfileId) {
    config.headers.set('tmxProfileId', tmxProfileId);
  }
  return config;
});

AxiosClient.interceptors.response.use(
  function handleSuccessfulResponse(res) {
    /* Traffic manager through akamai will interecept some responses
       and send back a 200 repsone, even though there is an error
       The most consistent field in these responses is the
       html it sends back which is the "oops we are fixing it"
       page you see from time to time. See comment on function
       for implementaiton details
    */
    /* Prefix match, as the page can carry a charset - `text/html; charset=UTF-8`. */
    const contentType = res.headers['content-type'];
    if (
      typeof contentType === 'string' &&
      contentType.toLowerCase().startsWith('text/html')
    ) {
      return handleAkamaiErrorResponse();
    }
    return res;
  },
  // function handleRejectedResponse(error) {
  // if (error.response.status === 401
  //   || (error.response.status === 400 && error?.response?.data?.errors[0]?.errorCode === 'AUTH_ERR_101')
  //   || error.response.status === 403) {
  //   window.location.replace('/auth/view/signin?redirect=/military/discount');
  // }
  //   return Promise.reject(error);
  // }
);

export const postRequest = <T = unknown>(
  apiUrl: string,
  apiHeaders?: RawAxiosRequestHeaders,
  data?: unknown,
): Promise<AxiosResponse<T>> =>
  AxiosClient.post<T>(apiUrl, data, { headers: apiHeaders });

export default AxiosClient;
